<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="clusterId" id="clusterId" type="text" pInputText>
            <label for="clusterId">ClusterId</label>
            @for (validation of validationMessages.clusterId; track validation) {
              <span>
                @if (form1.get('clusterId').hasError(validation.type) && (form1.get('clusterId').dirty || form1.get('clusterId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <!--<h6 for="clusterActive">Cluster Active Options</h6>-->
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['clusterActive']" inputId="clusterActive" [binary]="true"></p-checkbox>
            <span class="clusterActive-nm">Is Cluster Active?</span>
          </div>
          @for (validation of validationMessages.clusterActive; track validation) {
            <span>
              @if (form1.get('clusterActive').hasError(validation.type) && (form1.get('clusterActive').dirty || form1.get('clusterActive').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="externalUnitId" id="externalUnitId" type="text" pInputText>
            <label for="externalUnitId">External UnitId</label>
            @for (validation of validationMessages.externalUnitId; track validation) {
              <span>
                @if (form1.get('externalUnitId').hasError(validation.type) && (form1.get('externalUnitId').dirty || form1.get('externalUnitId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="unitId" id="unitId" type="text" pInputText>
            <label for="unitId">UnitId</label>
            @for (validation of validationMessages.unitId; track validation) {
              <span>
                @if (form1.get('unitId').hasError(validation.type) && (form1.get('unitId').dirty || form1.get('unitId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <!--<h6 for="unitActive">Unit Active Options</h6>-->
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['unitActive']" inputId="unitActive" [binary]="true"></p-checkbox>
            <span class="unitActive-nm">Is Unit Active?</span>
          </div>
          @for (validation of validationMessages.unitActive; track validation) {
            <span>
              @if (form1.get('unitActive').hasError(validation.type) && (form1.get('unitActive').dirty || form1.get('unitActive').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="propertyId" id="propertyId" type="text" pInputText>
            <label for="propertyId">PropertyId</label>
            @for (validation of validationMessages.propertyId; track validation) {
              <span>
                @if (form1.get('propertyId').hasError(validation.type) && (form1.get('propertyId').dirty || form1.get('propertyId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="pUID" id="pUID" type="text" pInputText>
            <label for="pUID">PUID</label>
            @for (validation of validationMessages.pUID; track validation) {
              <span>
                @if (form1.get('pUID').hasError(validation.type) && (form1.get('pUID').dirty || form1.get('pUID').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <!--<h6 for="rateActive">Rate Active Options</h6>-->
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['rateActive']" inputId="rateActive" [binary]="true"></p-checkbox>
            <span class="rateActive-nm">Is Rate Active?</span>
          </div>
          @for (validation of validationMessages.rateActive; track validation) {
            <span>
              @if (form1.get('rateActive').hasError(validation.type) && (form1.get('rateActive').dirty || form1.get('rateActive').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="rateId" id="rateId" type="text" pInputText>
            <label for="rateId">RateId</label>
            @for (validation of validationMessages.rateId; track validation) {
              <span>
                @if (form1.get('rateId').hasError(validation.type) && (form1.get('rateId').dirty || form1.get('rateId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="rateMarkup" id="rateMarkup" type="number" pInputText>
            <label for="rateMarkup">Rate Markup</label>
            @for (validation of validationMessages.rateMarkup; track validation) {
              <span>
                @if (form1.get('rateMarkup').hasError(validation.type) && (form1.get('rateMarkup').dirty || form1.get('rateMarkup').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="rateName" id="rateName" type="text" pInputText>
            <label for="rateName">rateName</label>
            @for (validation of validationMessages.rateName; track validation) {
              <span>
                @if (form1.get('rateName').hasError(validation.type) && (form1.get('rateName').dirty || form1.get('rateName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="rateNrOfPeople" id="rateNrOfPeople" type="number" pInputText>
            <label for="rateNrOfPeople">RateNr Of People</label>
            @for (validation of validationMessages.rateNrOfPeople; track validation) {
              <span>
                @if (form1.get('rateNrOfPeople').hasError(validation.type) && (form1.get('rateNrOfPeople').dirty || form1.get('rateNrOfPeople').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="contentStatus" id="contentStatus" type="text" pInputText>
            <label for="contentStatus">Content Status</label>
            @for (validation of validationMessages.contentStatus; track validation) {
              <span>
                @if (form1.get('contentStatus').hasError(validation.type) && (form1.get('contentStatus').dirty || form1.get('contentStatus').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="aRIStatus" id="aRIStatus" type="text" pInputText>
            <label for="aRIStatus">ARI Status</label>
            @for (validation of validationMessages.aRIStatus; track validation) {
              <span>
                @if (form1.get('aRIStatus').hasError(validation.type) && (form1.get('aRIStatus').dirty || form1.get('aRIStatus').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="srcData" id="srcData" [rows]="2" pInputTextarea></textarea>
            <label for="srcData">Src Data</label>
            @for (validation of validationMessages.srcData; track validation) {
              <span>
                @if (form1.get('srcData').hasError(validation.type) && (form1.get('srcData').dirty || form1.get('srcData').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>


      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (ruPropertiesStatusId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete RUPropertiesStatus</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!ruPropertiesStatusId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add RUPropertiesStatus</button>
              }

              @if (ruPropertiesStatusId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update RUPropertiesStatus</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>